import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useLayout } from '../../contexts/LayoutContext';
import { useWorkflows } from './hooks/useWorkflows';
import {
  EmptyState,
  Filters,
  LoadingSpinner,
  WorkflowTable,
} from './components';

export default function Workflows() {
  const { setSelectedRequestType } = useLayout();
  const navigate = useNavigate();

  const {
    myWorkflows,
    companyWorkflows,
    originalMyWorkflowsCount,
    originalCompanyWorkflowsCount,
    isFiltered,
    loading,
    mySortConfig,
    companySortConfig,
    handleSort,
    hasAnyData,
    setFilters,
    filters,
  } = useWorkflows();

  const handleResponseClick = (workflowId: string) => {
    setSelectedRequestType(null);
    navigate(`/workflows/${workflowId}`);
  };

  const getMaxHeight = (type: 'my' | 'company') => {
    if (type === 'my' && companyWorkflows.length === 0) {
      return 'calc(100vh - 185px)';
    }

    if (type === 'company' && myWorkflows.length === 0) {
      return 'calc(100vh - 185px)';
    }
    return '500px';
  };

  return (
    <>
      <LoadingSpinner open={loading} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 100px)',
          margin: '0 auto',
          maxWidth: 1400,
          overflow: 'hidden',
          padding: 2,
        }}
      >
        <Filters setFilters={setFilters} filters={filters} />

        {!hasAnyData && !loading ? (
          <EmptyState isFiltered={isFiltered} />
        ) : (
          <>
            <WorkflowTable
              workflows={myWorkflows}
              title="My Assigned Workflows"
              tableType="my"
              sortConfig={mySortConfig}
              onSort={handleSort}
              onResponseClick={handleResponseClick}
              totalCount={originalMyWorkflowsCount}
              isFiltered={isFiltered}
              maxHeight={getMaxHeight('my')}
            />

            <WorkflowTable
              workflows={companyWorkflows}
              title="Company Workflows"
              tableType="company"
              sortConfig={companySortConfig}
              onSort={handleSort}
              onResponseClick={handleResponseClick}
              totalCount={originalCompanyWorkflowsCount}
              isFiltered={isFiltered}
              maxHeight={getMaxHeight('company')}
            />
          </>
        )}
      </Box>
    </>
  );
}
